import { labelTokenizerPlatformCategoryId } from '../api/smartTokenizerMappers';

/**
 * Client-side filter for asset class cards (name, code, sector label, symbol, type, standard badge).
 */
export function filterAssetClasses(assetClasses, { searchQuery = '', sectorFilter = '' } = {}) {
  const q = searchQuery.trim().toLowerCase();
  const sector = sectorFilter || '';
  return (assetClasses || []).filter((ac) => {
    if (sector && ac.category !== sector) return false;
    if (!q) return true;
    const name = String(ac.name || '').toLowerCase();
    const code = String(ac.code || '').toLowerCase();
    const sectorLabel = labelTokenizerPlatformCategoryId(ac.category).toLowerCase();
    const ms = String(ac.marketSymbol || '').toLowerCase();
    const tu = String(ac.tradingUnit || '').toLowerCase();
    const ct = String(ac.classType || '').toLowerCase();
    const std = ac.isPlatformStandard ? 'standard asset class' : '';
    return (
      name.includes(q) ||
      code.includes(q) ||
      sectorLabel.includes(q) ||
      ms.includes(q) ||
      tu.includes(q) ||
      ct.includes(q) ||
      std.includes(q)
    );
  });
}
